import React from "react";
import {
  Flex,
  Box,
  Text,
  Divider,
  Stack,
  Icon,
} from "@chakra-ui/react";

import {
  BadgeCheck,
  BadgeInfo,
  BadgeX,
  Calendar,
  CreditCard,
  Landmark,
} from "lucide-react";

import { formatDate } from "utils/dateFormatter";
import InfoRow from "components/InfoRow/InfoRow";

const ViewCashout = ({ cashout }) => {
  if (!cashout) return null;

  const {
    first_name,
    last_name,
    phone_number_user,
    amount,
    channel,
    bank_name,
    bank_branch,
    account_number,
    claimed_at,
    status,
  } = cashout;

  const renderStatus = () => {
    if (status === "Approved") {
      return (
        <>
          <Icon as={BadgeCheck} color="green.500" ml={2} />
          <Text ml={1} color="green.500" fontSize="sm">
            Approved
          </Text>
        </>
      );
    }

    if (status === "Pending") {
      return (
        <>
          <Icon as={BadgeInfo} color="yellow.500" ml={2} />
          <Text ml={1} color="yellow.500" fontSize="sm">
            Pending
          </Text>
        </>
      );
    }

    if (status === "Rejected") {
      return (
        <>
          <Icon as={BadgeX} color="red.500" ml={2} />
          <Text ml={1} color="red.500" fontSize="sm">
            Rejected
          </Text>
        </>
      );
    }

    return null;
  };

  return (
    <Flex direction="column" p={8} width="100%">
      {/* 🔹 HEADER */}
      <Flex align="center">
        <Box>
          <Text fontSize="2xl" fontWeight="bold" display="flex" alignItems="center">
            {first_name} {last_name}
            {renderStatus()}
          </Text>

          <Text fontSize="sm" color="gray.500" mt={1}>
            {phone_number_user}
          </Text>
        </Box>
      </Flex>

      {/* 🔹 DATE */}
      <Flex mt={2} align="center">
        <Icon as={Calendar} size={16} color="gray.500" mr={1} />
        <Text fontSize="sm" color="gray.500">
          Date: {formatDate(claimed_at)}
        </Text>
      </Flex>

      <Divider my={6} />

      {/* 🔹 CASHOUT DETAILS */}
      <Box mb={6}>
        <Text fontSize="md" fontWeight="500" color="gray.500" mb={2}>
          Cashout Details
        </Text>

        <Stack spacing={3}>
          <InfoRow label="Amount" value={`P${amount}`} icon={CreditCard} />
          <InfoRow label="Channel" value={channel} icon={Landmark} />
          <InfoRow label="Bank Name" value={bank_name} icon={Landmark} />
          <InfoRow label="Account Number" value={account_number} icon={CreditCard} />
          <InfoRow label="Branch" value={bank_branch} icon={Landmark} />
        </Stack>
      </Box>
    </Flex>
  );
};

export default ViewCashout;